import { Dispatch, ReactNode } from 'react';
import { connect } from 'react-redux';
import { IReduxRootState } from '../../../app/reduxRootState.interface';
import {
    IAddressRequest,
    IAddressUpdateRequest,
    IAddressFieldConfig,
} from '../address/address.interface';
import { AddressesActions } from '../addressesActions';
import { AddressesAction } from '../addressesActionType';
import { NotificationsActions } from '../../../app/common/notifications/notificationsActions';
import { ICountryMap } from '../../../app/common/fields/country/country';
import { SupportedLanguage } from '../../../config/constants/supportedLanguage.enum';
import SupportLanguageHelper from '../../../utils/SupportLanguageHelper';
import AddressFormJP from './AddressFormJP';
import SortHelpers from '../../../utils/sortHelpers';

function mapStateToProps(state: IReduxRootState) {
    const {
        presentationConfig: {
            visibleFields: { address },
        },
    } = state.app;

    const lang: SupportedLanguage = SupportLanguageHelper.getSupportLanguage(state.app.locale);
    const countriesMap: ICountryMap =
        state.app && state.countries.countriesMap ? state.countries.countriesMap[lang] : {};
    const addressFieldConfig = Object.values(address).sort((a, b) => {
        return SortHelpers.sortAddressFieldAscendingOrder(
            a as IAddressFieldConfig,
            b as IAddressFieldConfig,
            lang,
        );
    }) as IAddressFieldConfig[];
    return {
        loading: state.addresses.loading,
        locale: lang,
        defaultCountry: state.app.clientConfig.countryCode,
        countriesMap: countriesMap,
        stateInputDisabled: state.addresses.stateInputDisabled,
        addressFieldConfig,
    };
}

function mapDispatchToProps(dispatch: Dispatch<AddressesAction>) {
    return {
        addAddress: (address: IAddressRequest) => {
            dispatch(AddressesActions.addAddress(address));
        },
        updateAddress: (addressUuid: string, updatedAddress: IAddressUpdateRequest) => {
            dispatch(AddressesActions.updateAddress(addressUuid, updatedAddress));
        },
        showWarning: (message: ReactNode) => {
            dispatch(NotificationsActions.showWarning(message));
        },
        resetStateInputDisabledStatus: () => {
            dispatch(AddressesActions.changeStateInputDisabled(true));
        },
    };
}

const AddressFormContainerJP = connect(mapStateToProps, mapDispatchToProps)(AddressFormJP);

export default AddressFormContainerJP;
